import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../../../../../../../components/Footer/Footer";
import InnerNav from "../../../../../../../components/InnerNav/InnerNav";
import { useFormData } from '../../../../ContextData/ContextData';

import "./Sd3.scss";

export default function Sd3() {
  const { userData } = useFormData();
  const [dashaData, setDashaData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDasha = async () => {
      try {
        const res = await axios.get(
          "https://core-c343.onrender.com/api/vimshottari-dasha",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
              level: "MD_AD_PD_SD", 
              variant: "3",
            },
          }
        );
        setDashaData(res.data);
      } catch (err) {
        console.error("Error fetching Dasha:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDasha();
  }, []);

  if (loading) {
    return <p className="loading-text">Loading Vimshottari Dasha...</p>;
  }

  if (!dashaData) {
    return <p className="error-text">Failed to load data.</p>;
  }

  return (
    <div className="dasha-container">
      <InnerNav />
      <h1 className="dasha-title">Vimshottari Dasha</h1>

      <div className="dasha-card">
        <h2 className="dasha-subtitle">Sub-Sub-Sub Periods</h2>
        <p className="dasha-balance">
          Balance Of Dasha : {dashaData.moonSign} — {dashaData.birthDate}
        </p>

        <div className="dasha-grid">
          {/* Map through summary (Main Periods) */}
          {dashaData.summary.map((item, idx) => (
            <div
              key={idx}
              className={`dasha-column ${idx === 1 ? "highlight" : ""}`}
            >
              <p className="dasha-header">-------------</p>
              <p className="dasha-header">{item}</p>
              <p className="dasha-header">-------------</p>

              {/* Show antarDasha that belong to this block */}
              {dashaData.antarDasha
                .filter((line) => !line.includes("------------------------"))
                .map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
